import tw from 'tailwind-styled-components'

export const TwTitle = tw.div`
  h1-desktop
  text-generic-black
  text-center
  cursor-default
`

export const TwTitle2 = tw.div`
  h5-desktop
  text-generic-black
  text-center
  cursor-default
`

export const TwTitle3 = tw.div`
  text-secondary
  text-xxxs2-regular
  text-center
  cursor-default
  tracking-[-0.3px]
`

export const TwItemTitle = tw.div`
  h1-semibold
  text-primary
  text-center
  cursor-default
  w-full
`

export const TwItemTitleSupport = tw.div`
  text-body
  text-secondary
  text-center
  cursor-default
  mt-4
  w-full
`

export const TwItemBox = tw.div`
  px-12
  py-8
  flex
  flex-col
  gap-4
  rounded-12
  bg-[#F5F5F7]
  cursor-default
  w-full
`

export const TwItemCheckBox = tw.div`
  flex
  flex-row
  gap-8
`

export const TwItemCheckBoxLabel = tw.div`
  body-long-regular
  flex
  items-center
`
